import { render, staticRenderFns } from "./RentSetting2.vue?vue&type=template&id=720f7060"
import script from "./RentSetting2.vue?vue&type=script&lang=js"
export * from "./RentSetting2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports